import { AutoDocumentExtraction } from 'query/study';

export const deriveExtractionSuggestion = (
  extraction: AutoDocumentExtraction | null | undefined
): { suggestion: string | null; has_suggestion: boolean } => {
  if (!extraction) {
    return { suggestion: null, has_suggestion: false };
  }

  const suggestion = extraction.suggestion;

  return { suggestion, has_suggestion: Boolean(suggestion) };
};
